const { required } = require('vuelidate/lib/validators')

export default {
  newData: {
    artista: {
      required
    }
  }
}